import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup.AmountSearchFields', {
    amountFieldTitle: 'Amount ({currency})',
    amountFromText: 'From',
    amountToText: 'To',
    amountRowNote: 'Organisation default currency is used',
    amountGreaterEqualsPlaceholder: 'Enter amount',
    amountLessEqualsPlaceholder: 'Enter amount',
});
